// File: /src/pages/IssueCertificate.js
import React, { useState, useEffect } from 'react';
import './IssueCertificates.css';
import { FaFileUpload, FaEye, FaEdit, FaTrash, FaPenFancy, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { getAllVCs } from '../../api/ssiAPI';
import { getMe } from '../../api/loginAPI';

function IssueCertificate() {
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    startDate: '',
    endDate: '',
    template: ''
  });
  const navigate = useNavigate();
  const [issuanceMethod, setIssuanceMethod] = useState('manual');
  const [certificates, setCertificates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

   const [user, setUser] = useState(null);
  
      const darkMode = document.body.classList.contains('dark-mode')
    
useEffect(() => {
  async function fetchUserAndVCs() {
    try {
      const userData = await getMe();
      console.log('UserData', userData);
      setUser(userData);

      if (userData?.Id) {
        const data = await getAllVCs(userData.Id);
        setCertificates((data?.response || []).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      }
    } catch (err) {
      console.error('❌ Failed to fetch user or issued VCs:', err);
    }
  }

  fetchUserAndVCs();
}, []);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { company, name, startDate, endDate } = formData;
    if (!company || !name || !startDate || !endDate) {
      Swal.fire('Error', 'All fields are required.', 'error');
      return;
    }

    Swal.fire('Success', 'Certificate issued successfully!', 'success');
    setFormData({ company: '', name: '', startDate: '', endDate: '' });
    setShowForm(false);
  };

  const paginatedCertificates = certificates.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(certificates.length / itemsPerPage);

  return (
    <div className="page issue-layout">
      <h2 className="issue-title">Issue Certificate</h2>

      <div className="card-container">
        <div 
          className="issue-card" 
          onClick={() => navigate('/templates', { state: { method: 'manual' } })}
        >
          <FaPenFancy className="card-icon" />
          <h3>Manual Issuance</h3>
          <p>Fill out certificate info one by one manually.</p>
        </div>
        <div 
          className="issue-card" 
          onClick={() => navigate('/templates', { state: { method: 'bulk' } })}
        >
          <FaFileUpload className="card-icon" />
          <h3>Bulk Issuance</h3>
          <p>Upload an Excel file to issue multiple certificates.</p>
        </div>
      </div>

      <div className="table-section">
        <h3>Recently Issued</h3>
        <table>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Name</th>
              <th>Company</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th className="icon-col">View</th>
              {/* <th className="icon-col">Edit</th> */}
              <th className="icon-col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {paginatedCertificates.map((cert, index) => (
              <tr key={cert._id}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>{cert.vc.credentialSubject?.[0]?.subjectName || '-'}</td>
                <td>{cert.vc.credentialSubject?.[0]?.companyName || '-'}</td>
                <td>{cert.vc.credentialSubject?.[0]?.startDate || '-'}</td>
                <td>{cert.vc.credentialSubject?.[0]?.endDate || '-'}</td>
                <td className="icon-col"><FaEye className="table-icon icon-view" /></td>
                {/* <td className="icon-col"><FaEdit className="table-icon icon-edit" /></td> */}
                <td className="icon-col"><FaTrash className="table-icon icon-delete" /></td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination-controls">
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
            <FaArrowLeft />
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
            <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
}

export default IssueCertificate;
